import script from "./DashboardAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardAdmin.vue?vue&type=script&setup=true&lang=js"

import "./DashboardAdmin.vue?vue&type=style&index=0&id=175e038d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-175e038d"]])

export default __exports__